import React, { useEffect, useState, useRef } from 'react';
import { Button, Dropdown, Modal, Space, Tooltip } from 'antd';

import needHelpIc from "../../assets/needHelp.png"
import { setGameIntroSteps, setIntroSteps, setLogin, setStep, playAudio } from '../../reduxStore/actions/action';
import { connect } from 'react-redux';
import settings from "../../assets/settings-icons/Settings.svg";
import ProfileModal from '../dashboard/profileModal';
import NeedHelp from './needHelp';


function SettingsModal({ isOpenModal, setIsOpenModal,
    step, setLogin, setIntroSteps, openSettings, setOpenSettings,
    resume, selectTokens, setStep, setIsOpenModalSetting, isPlaying, playAudio, userDetails, gameAssets, utilAssets }) {
    const [isSoundOn, setIsSoundOn] = useState(true);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [isNeedOpen, setIsNeedOpen] = useState(false);
    console.log("isNeedOpen", isNeedOpen)
    const items = [
        {
            label: (
                <Tooltip title="Close" placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div onClick={() => { setOpenSettings(false); setIsOpenModalSetting(false); }}>
                        <img className="btn-img-settings" src={utilAssets?.closeIcon} />
                    </div>
                </Tooltip>
            ),
            key: '0',
        },
        {
            label: (
                <Tooltip title="Profile" placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div onClick={() => { setIsProfileOpen(true); }}>
                        <img className="btn-img-settings" src={utilAssets?.profileIcon} />
                    </div>
                </Tooltip>
            ),
            key: '1',
        },
        {
            label: (
                <Tooltip title={isSoundOn ? "Mute audio" : "Unmute audio"} placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div id="audio-icon" onClick={() => {
                        /* setOpenSettings(false);
                        setIsOpenModalSetting(false); */
                        const audio = document.getElementById("audio-tag");
                        if (audio) {
                            if (audio.paused) {
                                audio?.play()?.catch(error => {
                                    console.error("Error playing audio:", error);
                                });
                                setIsSoundOn(true);
                            } else {
                                audio?.pause()?.catch(error => {
                                    console.error("Error pausing audio:", error);
                                });
                                setIsSoundOn(false);
                            }
                        }
                    }}>
                        <img className="btn-img-settings" src={utilAssets?.audioIcon} />
                    </div>
                </Tooltip>
            ),
            key: '2',
        },
        {
            label: (
                <Tooltip title="Introduction" placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div onClick={() => { setStep(-2); setIntroSteps(0); setOpenSettings(false); setIsOpenModalSetting(false); }}>
                        <img className="btn-img-settings" src={utilAssets?.infoIcon} />
                    </div>
                </Tooltip>
            ),
            key: '3',
        },
        {
            label: (
                <Tooltip title="Need Help" placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div onClick={() => { setIsNeedOpen(true) }}>
                        <img className="btn-img-settings" /* src={utilAssets?.infoIcon}  */ src={needHelpIc} />
                    </div>
                </Tooltip>
            ),
            key: '4',
        },
        {
            label: (
                <Tooltip title="Log Out" placement="left" overlayInnerStyle={{ backgroundColor: "#FFDBAA", color: "#44301E", fontWeight: 600 }}>
                    <div onClick={() => {
                        setLogin();
                        setOpenSettings(false);
                        setIsOpenModalSetting(false);
                        const audio = document.getElementById("audio-tag");
                        audio.pause();
                    }}>
                        <img className="btn-img-settings" src={utilAssets?.logoutIcon} />
                    </div>
                </Tooltip>
            ),
            key: '5',
        },
    ];


    return (
        <div>
            <Modal
                visible={isOpenModal}
                onCancel={() => setIsOpenModal(false)}
                footer={null}
                closeIcon={false}
                className='r-c-c token-model'
                maskClosable={false}
                style={{ overflow: 'hidden !important', top: "0px" }}
                bodyStyle={{ height: "100vh", width: "90vw", overflow: 'hidden !important', }}
            >
                <div className="r-c-c" style={{ width: "100%", height: "100%", textAlign: "center", color: "#FFFFFF", fontSize: '5vw' }}>
                    PAUSE
                </div>
                <div style={{ width: '100%', height: '100%' }}>
                    <div id="lock-btn-2" style={{ right: '0%', top: '1.4%' }}>
                        <Dropdown
                            menu={{
                                items,
                            }}
                            trigger={['click']}
                            open={openSettings}
                            className='setting-drop'

                        >
                            <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                    <img
                                        className="btn-img-settings"
                                        src={utilAssets?.settingIcon}
                                        onClick={() => { setOpenSettings(!openSettings); setIsOpenModalSetting(false) }}
                                    />
                                </Space>
                            </a>
                        </Dropdown>
                    </div>
                </div>
            </Modal>
            {isProfileOpen && <ProfileModal isProfileOpen={isProfileOpen} setIsProfileOpen={setIsProfileOpen} userDetails={userDetails} utilAssets={utilAssets} />}
            {isNeedOpen && <NeedHelp isNeedOpen={isNeedOpen} setIsNeedOpen={setIsNeedOpen} />}
        </div>
    )
}

const mapStateToProps = state => {

    const { step, resume, selectTokens, isPlaying, userDetails, gameAssets, utilAssets } = state?.SeTu;
    return { step, resume, selectTokens, isPlaying, userDetails, gameAssets, utilAssets }
}
const mapDispatchToProps = dispatch => ({

    setLogin: (val) => dispatch(setLogin(val)),
    setIntroSteps: (val) => dispatch(setIntroSteps(val)),
    setStep: (val) => dispatch(setStep(val)),
    setGameIntroSteps: (val) => dispatch(setGameIntroSteps(val)),
    playAudio: (val) => dispatch(playAudio(val))
})


export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal)
